import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Select from 'react-select';

import { getImplementSubgroup, getGroup, getSubgroup, setRowInReducer, setInitialState } from '../../../actions/resources/ImplementsActions';
import i18n from '../../../i18n/i18n';
import immutable from 'seamless-immutable';
import AddImplementSubgroup from './AddImplementSubgroup';
import checkboxHOC from "react-table/lib/hoc/selectTable";
const CheckboxTable = checkboxHOC(ReactTable);

export class ViewImplementSubgroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            add: false,
            edit: this.props.edit,
            showFilters: false,
            selection: [],
            selectAll: false
        };
    }

    componentDidMount() {
        if (this.props.implementGroupDropdown.length === 0) {
            this.props.getGroup();
        }
        if (this.props.implementSubgroupDropdown.length === 0) {
            this.props.getSubgroup();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.deleted === true) {
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getImplementSubgroup(wrapped.state);
            this.setState({
                selection: [],
                selectAll: false,
            })
            this.props.setInitialState('deleted');
        }
        if (nextProps.implementSubgroupsPostingSuccess === true) {
            this.setState({
                selection: [],
                name: ''
            })
            this.props.handleClose();
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getImplementSubgroup(wrapped.state);
            this.props.setInitialState('implementSubgroupsPostingSuccess');
        }
        this.setState({
            add: nextProps.add,
            showFilters: nextProps.showFilters,
            implementGroupDropdown: immutable.asMutable(nextProps.implementGroupDropdown.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            groupFetching: nextProps.groupFetching,
            groupFetchingFailed: nextProps.groupFetchingFailed,
            implementSubgroupDropdown: immutable.asMutable(nextProps.implementSubgroupDropdown.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            subgroupFetching: nextProps.subgroupFetching,
            subgroupFetchingFailed: nextProps.subgroupFetchingFailed,
        })
        if (nextProps.add == true && nextProps.edit == false) {
            this.props.setInitialState('implementSubgroupObj');
            this.setState({
                selection: [],
                name: ''
            })
        }
    }


    onSearchClick() {
        this.setState({ showFilters: !this.state.showFilters });
    }
    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
        } else {
            selection.push(key);
        }
        this.setState({ selection }, function () {
            if (selection.length == 1) {
                let row1 = this.props.implement_subgroup.filter((impSubgroup) => {
                    return impSubgroup.id == selection;
                })
                this.props.setRowInReducer(row1[0], 'implementSubgroupObj');
            }
        });
        this.props.setSelection(selection, 'implement_subgroup');
    };

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection });
        this.props.setSelection(selection, 'implement_subgroup');

    };

    isSelected = key => {
        return this.state.selection.includes(key);
    };


    render() {
        let content;
        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return {
                        style: {
                            backgroundColor: selected ? "#ACDAF1" : "inherit"
                        }
                    };
                }
                return {};
            }
        };
        content =
            <div className="page">
                <CheckboxTable data={this.props.implement_subgroup}
                    ref={r => (this.checkboxTable = r)}
                    keyField={'id'}
                    columns={this.columns}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    showPaginationTop
                    showPaginationBottom={false}
                    pages={this.props.implementSubgroupsPages}
                    loading={this.props.implementSubgroupsFetching}
                    manual
                    onFetchData={(state, instance) => this.props.getImplementSubgroup(state, instance)}
                    className="-striped -highlight"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps}
                    PreviousComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF',
                        }}>{props.children}</button>
                    )}
                    NextComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF'
                        }}>{props.children}</button>
                    )}
                />
                {this.state.add && <AddImplementSubgroup add={this.state.add} edit={this.props.edit}
                    handleClose={this.props.handleClose} />}
            </div>

        return (
            <div>
                {content}
            </div >
        )
    }

    columns = [
        {
            Header: 'Implement group name',
            accessor: 'prikljucna_masina_grupa_naziv',
            Filter: ({ filter, onChange }) =>
                <Select
                    isMulti
                    name="naziv"
                    onChange={value => {
                        onChange(value)
                    }}
                    closeMenuOnSelect={false}
                    options={this.state.implementGroupDropdown}
                    className="multi-select-in-filter"
                    classNamePrefix="select"
                    placeholder={i18n.t('Select')}
                />
        },
        {
            Header: i18n.t('Title'),
            accessor: 'naziv',
            Filter: ({ filter, onChange }) =>
                <Select
                    isMulti
                    name="naziv"
                    onChange={value => {
                        onChange(value)
                    }}
                    closeMenuOnSelect={false}
                    options={this.state.implementSubgroupDropdown}
                    className="multi-select-in-filter"
                    classNamePrefix="select"
                    placeholder={i18n.t('Select')}
                />
        },
        {
            Header: i18n.t('Icon name'),
            accessor: 'ime_ikonice',

        },
        {
            Header: i18n.t('Priority'),
            accessor: 'prioritet',
        },
        {
            Header: i18n.t('Color'),
            accessor: 'boja',
        },
    ];
};

function mapStateToProps(state) {
    return {
        implementGroupDropdown: state.implementReducer.implementGroupDropdown,
        groupFetching: state.implementReducer.groupFetching,
        groupFetchingFailed: state.implementReducer.groupFetchingFailed,
        implement_subgroup: state.implementReducer.implement_subgroup,
        implementSubgroupsFetching: state.implementReducer.implementSubgroupsFetching,
        implementSubgroupsFetchingFailed: state.implementReducer.implementSubgroupsFetchingFailed,
        implementSubgroupsPages: state.implementReducer.implementSubgroupsPages,
        implementSubgroupDropdown: state.implementReducer.implementSubgroupDropdown,
        implementSubgroupsPostingSuccess: state.implementReducer.implementSubgroupsPostingSuccess,
        subgroupFetching: state.implementReducer.subgroupFetching,
        deleted: state.implementReducer.deleted,
        subgroupFetchingFailed: state.implementReducer.subgroupFetchingFailed,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getGroup: () => dispatch(getGroup()),
        getSubgroup: () => dispatch(getSubgroup()),
        setInitialState: (component) => dispatch(setInitialState(component)),
        setRowInReducer: (rowInfo, name) => dispatch(setRowInReducer(rowInfo, name)),
        getImplementSubgroup: (state, instance) => dispatch(getImplementSubgroup(state, instance))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewImplementSubgroup)